// src/services/userSettings.service.js
import { api } from './api';

class UserSettingsService {
    /**
     * Get user settings from backend
     */
    async getUserSettings() {
        try {
            const response = await api.get('/api/user-settings');
            return response.data;
        } catch (error) {
            console.error('Error fetching user settings:', error);
            throw error;
        }
    }

    /**
     * Update user settings
     */
    async updateUserSettings(settings) {
        try {
            const response = await api.put('/api/user-settings', settings);
            return response.data;
        } catch (error) {
            console.error('Error updating user settings:', error);
            throw error;
        }
    }
}

const userSettingsService = new UserSettingsService();
export default userSettingsService;
